export type RouteScrollMode = 'app-shell' | 'route-shell';

export const DEFAULT_ROUTE_SCROLL_MODE: RouteScrollMode = 'app-shell';
